// extracted by mini-css-extract-plugin
export default {"Line":"BookingGenericInfosCard_Line__SfKDB","Line__title":"BookingGenericInfosCard_Line__title__1GqOh"};